import { Switch } from 'antd';
import React from 'react';

type SwitchProps = Omit<React.ComponentProps<typeof Switch>, 'value'>;

interface Props extends SwitchProps {
    label: string;
    value?: boolean;
    onLabelClick?(): void;
    separator?: string;
}

const SwitchForm: React.FC<Props> = ({ label, value, onChange, onLabelClick, separator = ':', ...rest }) => (
    <>
        <div style={{ gridColumn: '1 / 3', cursor: onLabelClick ? 'pointer' : '' }}>
            <strong onClick={onLabelClick}>
                {label}
                {separator}
            </strong>
        </div>
        <div style={{ gridColumn: '3 / 6' }}>
            <Switch checked={value} onChange={onChange} {...rest} />
        </div>
    </>
);

export default React.memo(SwitchForm);
